import moment from 'moment';
import { store } from '../../store';
import { configSettings } from '../../config/configSettings';
import * as actions from '../../actions/date.Action';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../../scenes/sharedComponent/messageBox';

export function allowOnlyPositiveNumeric(value) {
    let number;
    number = value.replace(/[^0-9]/g, "");

    return value = number;
}

export function allowOnlyDotAndPositiveNumeric(value) {
    value = value === '.' ? value : isNaN(value) ? "" : value;
    return value.replace(/[^0-9.]/g, "");
}

export function getMMDDYYYYDateTime(dateTime) {
    return dateTime ? moment(dateTime).format("MM/DD/YYYY") : "";
}
export function getMMDDYYYYDateTimeFromUTC(dateTime) {
    const dateObj = new Date(dateTime);
    const localTime =new Date(`${dateObj.getMonth()+1}/${dateObj.getDate()}/${dateObj.getFullYear()} ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}.${dateObj.getMilliseconds()} UTC`);
    return dateTime ? moment(localTime).format("MM/DD/YYYY") : "";
}

export function getDDMMYYYYDateTime(dateTime) {
    return dateTime ? moment(dateTime).format("DD/MM/YYYY") : "";
}

export function allowAllValuesExceptSpace(event) {
    let char = event.target.value.replace(/\s/g, "");
    event.target.value = char;
}

export function allowOnlyPositiveIntegerValue(event, isValue = false) {
    let value = isValue ? ((isNaN(event) || event !== "") ? event.toString() : event) : event.target.value;
    let number = value.replace(/[^0-9]/g, "");
    if (isValue)
        return event = number;
    else
        return event.target.value = number;
}

export function emailValidation(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isValidMail = re.test(email);
    return isValidMail;
}

export function deviceNameRegExp(value) {
    let data = value.replace(/[^a-zA-Z0-9_ ]/g, "");
    return data;
}

export function hoursFormation(hour) {
    hour = hour.toString();
    return isNaN(parseFloat(hour)) ? "" : Number(parseFloat(hour).toFixed(2)).toString();
}
export function getFormatedTotalHours(hour) {
    hour = typeof (hour) == 'string' ? parseFloat(hour) : hour;
    return hour % 1 == 0 ? hour : hour.toFixed(2);
}

export function convertToHHMM(inputString) {
    const [hours, minutes] = inputString.split(":");
    const formattedHours = hours ? (parseInt(hours) < 10 ? hours.toString().padStart(2, 0) : hours) : '';
    const formattedMinutes = minutes ? (parseInt(minutes) < 10 ? minutes.toString().padStart(2, 0) : minutes) : '';
    const formattedTime = `${formattedHours}:${formattedMinutes}`;
    return formattedTime;
}

export function timeSpliting(time) {
    if (time === Constants.NOT_APPLICABLE) return ["", ""];
    return time ? time.split(":") : [];
}

export function removeActiveEventListener() {
    let eventList = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'touchend', 'touchmove', 'touchcancel'];
    eventList.map((ev) => {
        window.removeEventListener(ev, handleActivity);
    });
}

export function handleActivity() {
    let reduxStore = store.getState();
    var lastActivityDateTime = reduxStore.dateReducer.date.lastActivityDateTime;
    if (lastActivityDateTime) {
        lastActivityDateTime = new Date(lastActivityDateTime);
        var logOutCheckTime = new Date(new Date().getTime() - configSettings.logoutTime);
        if (logOutCheckTime >= lastActivityDateTime) {
            removeActiveEventListener();
            store.dispatch(actions.lastActivityDateTime(''));
            store.dispatch({ type: 'Logout' });
        }
        else {
            store.dispatch(actions.lastActivityDateTime(new Date()));
        }
    }
}

export function setupActivityListeners() {
    handleActivity();
    store.dispatch(actions.lastActivityDateTime(new Date()));
    let eventList = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'touchend', 'touchmove', 'touchcancel'];
    eventList.map((ev) => {
        window.addEventListener(ev, handleActivity);
    });
};

export function replaceNullWithEmptyString(str) {
    return str ?? "";
}

export function replaceNullWithStringInObject(data) {
    if (data) {
        for (let k in data) {
            data[k] = data[k] ?? "";
        }
    }
}
function getBase64Size(base64Content) {
    if (!base64Content || typeof base64Content !== 'string') return 0;

    let padding = (base64Content.endsWith('==') ? 2 : base64Content.endsWith('=') ? 1 : 0);
    let sizeInBytes = (base64Content.length * 3) / 4 - padding;
    
    const sizeInKB = sizeInBytes / 1024;
    const sizeInMB = sizeInKB / 1024;
    return sizeInMB;
}

export async function maximumImageCheck(savedAttachments, selectedImages, isLower = false, checkMax = false) {
    let selectedImageList = selectedImages.filter(a => a.hasOwnProperty('dataURL'));
    let totalSize = 0;
    if (selectedImageList.length > 10) {
        MessageBox(Constants.ATTACHMENT_RESTRICTION_VALIDATION, Constants.ERROR);
        return { success: false };
    }
    if (checkMax) {
        const activeAttachmentLength = 10 - savedAttachments.filter(a => a.isActive || a.IsActive).length;
        selectedImageList = selectedImageList?.slice(0, activeAttachmentLength) ?? [];
    }

    // Calculate total size of already saved attachments
    savedAttachments.forEach((data) => {
        const content = data.isActive || data.IsActive ? data.attachmentContent || data.AttachmentContent || "" : "";
        totalSize += getBase64Size(content);
    });

    // Process compression
    for (let image of selectedImageList) {
        if (image.dataURL) {
            const compressed = await compressBase64(image.dataURL, 0.9, 800);
            totalSize += getBase64Size(image.dataURL ? compressed?.split(',')[1] : "");

            if (totalSize > Constants.MAX_ATTACHMENT_SIZE_MB) {
                MessageBox(Constants.TOTAL_ATTACHMENT_SIZE_EXCEEDED, Constants.ERROR);
                return { success: false };
            }

            if (compressed) {
                let obj = {
                    Id: 0,
                    AttachmentType: image.file.type ? image.file.type : "",
                    AttachmentName: image.file.name ? image.file.name : '',
                    AttachmentContent: compressed ? compressed?.split(',')[1] : "",
                    IsActive: true
                };
                if (isLower) {
                    obj = {
                        id: 0,
                        attachmentType: image.file.type ? image.file.type : "",
                        attachmentName: image.file.name ? image.file.name : '',
                        attachmentContent: compressed ? compressed.split(',')[1] : "",
                        isActive: true
                    };
                }
                savedAttachments.push(obj);
            }
        }
    };

    return { success: true, savedAttachments };
}


function compressBase64(base64, quality = 0.6,targetWidth=800) {
     if (!base64 || typeof base64 !== 'string') {
            return base64;
        }

    return new Promise((resolve,reject) => {
        const img = new Image();
        img.onload = () => {

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                return base64; //Canvas 2D context is not supported
            }

            const scaleRatio = targetWidth / img.width;
            const newHeight = Math.round(img.height * scaleRatio);
            canvas.width = targetWidth;
            canvas.height = newHeight;
            ctx.clearRect(0, 0, targetWidth, newHeight);
            ctx.drawImage(img, 0, 0,targetWidth,newHeight);
            try {
                const type = base64.startsWith('data:image/png') ? 'image/png' : 'image/jpeg';
                const compressedBase64 = canvas.toDataURL(type, quality);
                resolve(compressedBase64);
            }
           catch(err){
            reject(err);
           }
        }
        img.onerror = () => resolve(base64); // fallback
        img.src = base64;
    });
}